import {ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MaterialConfiguration} from 'app/core/components/workflow-new/material/configurations/material-configuration';
import {LinkActions} from 'app/core/components/workflow-new/common/base-card-configuration';
import {RequestService} from 'app/core/services/request.service';
import {Subject} from 'rxjs/Subject';
import {ActivatedRoute, Router} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {RxComponent} from 'app/shared/components/common/rx.component';
import {ReplaySubject} from 'rxjs/ReplaySubject';
import {ConfigService} from 'app/core/services/config.service';

declare var $;
@Component({
  selector: 'itpx-material-details',
  templateUrl: './material-details.component.html',
  styleUrls: ['./material-details.component.css', '../../common/style.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MaterialDetailsComponent extends RxComponent implements OnInit {
  @Input() props: any;
  @Input() conf: MaterialConfiguration;
  @Input() actions: string = 'enabled';
  @Output() expandClicked$ = new EventEmitter<void>();
  @Input() changeText$: Observable<any>;
  @Input() entry: string;
  @Output() triggerParent = new EventEmitter<any>();
  private markCompleted$ = new Subject<string>();
  private propagate$ = new ReplaySubject<boolean>(1);
  private table: ElementRef;
  private tagType: string;
  private expired: boolean;
  private linkActions = LinkActions;
  constructor(
    private requestService: RequestService,
    private configService: ConfigService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    super();
  }

  ngOnInit() {
    Object.assign(this, this.conf);
    if (!this.changeText$) {
      this.changeText$ = Observable.empty();
    }
    this.changeText$.bindToLifecycle(this).startWith({}).subscribe(_ => this.propagate$.next(true));
    this.markCompleted$.switchMap(id => {
      let url = this.configService.get('server').url + this.configService.get('endpoints').solar.content.markComplete.api + '/' + id;
      return this.requestService.post(url, {}).map(_ => _.data).neverError();
    }).neverError().bindToLifecycle(this).subscribe(res => { this.props.contents[0].completed = true; this.triggerParent.emit(res);});
  }

  onExpandClicked() {
    this.expandClicked$.emit();
  }

  markCompleted() {
    if (this.props && this.props.contents && this.props.contents.length) {
      this.markCompleted$.next(this.props.contents[0].id)
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/material/material-details/material-details.component.ts